import { apiFetch } from '@/lib/api-client';
import type { TicketEnrichmentResponse, OrderWorkflowEntry } from '@uniticket/shared';

// JVID Address Enrichment — read-only DMP context for the address a ticket points at.
// Internal-only endpoints (gated server-side to Unifiber staff).

export async function fetchTicketEnrichment(ticketId: string, jvid?: number | null) {
  // N45 — l'adresse du ticket ouverte dans la fenêtre ; absente = la principale.
  return apiFetch<{ data: TicketEnrichmentResponse }>(`/tickets/${ticketId}/enrichment${jvid != null ? `?jvid=${jvid}` : ''}`);
}

/** Lazy per-order workflow timeline (loaded when a reviewer expands an order row). */
export async function fetchOrderWorkflow(ticketId: string, orderId: number) {
  return apiFetch<{ data: OrderWorkflowEntry[] }>(
    `/tickets/${ticketId}/enrichment/orders/${orderId}/workflow`,
  );
}
